import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { usePanelAccess } from '../../context/PanelAccessContext';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../core/store/store';
import {
  canPanelModeratePlayers,
  canPanelAdminTier,
  canPanelManagePremium,
} from '../../panelAccess/panelRoleAccess';

const PanelJoueursPage: React.FC = () => {
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { hasAccessToSection, loading } = usePanelAccess();
  const location = useLocation();
  const roleId = currentUser?.roles_id ?? 0;

  if (loading || !currentUser) return null;

  const tabs = [
    {
      to: '/panel/joueurs/liste',
      can: hasAccessToSection('salon_joueurs') || canPanelModeratePlayers(roleId),
    },
    {
      to: '/panel/joueurs/fiches',
      can: hasAccessToSection('admin') || canPanelAdminTier(roleId),
    },
    {
      to: '/panel/joueurs/premium',
      can: hasAccessToSection('player_premium') || canPanelManagePremium(roleId),
    },
  ];

  const visibleTabs = tabs.filter((t) => t.can);
  if (!visibleTabs.length) return <Navigate to="/panel/dashboard" replace />;

  if (location.pathname === '/panel/joueurs' || location.pathname === '/panel/joueurs/') {
    return <Navigate to={visibleTabs[0].to} replace />;
  }

  return <Outlet />;
};

export default PanelJoueursPage;
